import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Checkbox,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { countryIdentificationControl } from "./countryIdentificationControls";

import { stateCodes } from "./stateCodes";
import axiosInstance from "../../../../axiosInstance";
import { useTranslation } from "react-i18next";

/** Indian income-tax PAN: five letters, four digits, one letter (ten characters). */
const INDIA_PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

function ConversionItem({ type, idx, conversion, lightMode, selectedValue }) {
  // conversion["@attributes"].type
  return (
    <Grid item xs={12} sm={6} xl={4} key={idx}>
      <Card
        sx={{
          cursor:
            conversion["@attributes"].locked === "true" ||
              (type === "single" &&
                conversion["@attributes"].type === "Bank Transfer")
              ? "default"
              : "pointer",
          display: "flex",
          alignItems: "center",
          marginBottom: "2rem",
          minHeight: "200px",
          position: "relative",
          boxShadow:
            conversion["@attributes"].locked === "true" ||
            (type === "single" &&
              conversion["@attributes"].type === "Bank Transfer" &&
              "none"),
          "&:before": {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: `${lightMode ? `#efefefc2` : `#686868e6`} `,
            zIndex: 1,
            display:
              conversion["@attributes"].locked === "true" ||
                (type === "single" &&
                  conversion["@attributes"].type === "Bank Transfer")
                ? "block"
                : "none",
          },

          outline:
            selectedValue === conversion["@attributes"].type
              ? `3px solid ${lightMode ? `#F08049` : `#ffffff61`} `
              : "none",
          // border:
          //   selectedValue === conversion["@attributes"].type
          //     ? `3px solid ${
          //         lightMode ? `#F08049` : `#ffffff61`
          //       } `
          //     : "none",
        }}
      >
        <FormControlLabel
          sx={{
            margin: "0",
            height: "100%",
            width: "100%",
            padding: "1rem",
            minHeight: "200px",
          }}
          key={idx}
          value={conversion["@attributes"].type}
          disabled={
            conversion["@attributes"].locked === "true"
              ? true
              : type === "single" &&
                conversion["@attributes"].type === "Bank Transfer"
                ? true
                : false
          }
          control={<Radio />}
          label={
            <Box sx={{ display: "flex" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRight: "1px solid #efefef",
                  marginRight: "1rem",
                  width: "75px",
                  paddingRight: "1rem",
                }}
              >
                <img
                  alt={conversion["@attributes"]?.type || ""}
                  src={conversion["@attributes"].logo}
                  style={{
                    maxWidth: "100px",
                    width: "100%",
                    marginRight: "1rem",
                  }}
                />
              </Box>
              <Box>
                <Typography
                  variant={"h6"}
                  sx={{
                    color:
                      conversion["@attributes"].locked === "true"
                        ? "grey"
                        : type === "single" &&
                          conversion["@attributes"].type === "Bank Transfer"
                          ? "grey"
                          : "#F08049",
                    borderBottom: "1px solid #efefef",
                    marginBottom: "1rem",
                  }}
                >
                  {conversion["@attributes"].type}
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <Typography sx={{ marginRight: ".25rem" }} variant={"h6"}>
                    {conversion["@attributes"]?.currency}
                  </Typography>
                  <Typography variant={"h6"}>
                    {conversion.converted_amount}
                  </Typography>
                </Box>
                {conversion["@attributes"].locked === "true" ? (
                  <Box sx={{ lineHeight: "16px" }}>
                    <Typography
                      sx={{ zIndex: 9 }}
                      color="#F08049"
                      position={"relative"}
                      variant={"caption"}
                    >
                      <strong>
                        Reason: {conversion["@attributes"].lock_reason}
                      </strong>
                    </Typography>
                  </Box>
                ) : null}
              </Box>
            </Box>
          }
        />
      </Card>
    </Grid>
  );
}
export default function TransferMate({
  totalPrice,
  countriesInit,
  setPaymentMethod,
  setCountryCode,
  setPayerDocument,
  setState,
  identificationControl,
  setIdentificationControl,
  stateCodeControl,
  setStateCodeControl,
  chineseNameControl,
  setChineseNameControl,
  setChineseName,
  indiaSourceOfFund,
  setIndiaSourceOfFund,
  indiaDeclarationAmt,
  setIndiaDeclarationAmt,
  selectedStudent,
  paymentType,
  needsExtraPayerFields,
  payerFieldsComplete,
  onPayerStepSubmitted,
  isLoan,
  setIsLoan,
  sourceOfFunds,
  setSourceOfFunds,

}) {
  const { t } = useTranslation();

  const [age, setAge] = useState("");

  const [conversion, setConversion] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const lightMode = true;
  const [identificationValue, setIdentificationValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState(null);
  /** After required payer fields, user confirms before conversion options appear. */
  const [payerStepConfirmed, setPayerStepConfirmed] = useState(false);
  const [panTouched, setPanTouched] = useState(false);

  const normalizedIndiaPan = (identificationValue || "").trim().toUpperCase();
  const indiaPanFormatValid = INDIA_PAN_REGEX.test(normalizedIndiaPan);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleChangeState = (event) => {
    setSelectedState(event.target.value);
  };

  const handleChangeChineseName = (event) => {
    setChineseName(event.target.value);
  };

  const handleChangeConversion = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (selectedState) {
      setState(selectedState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState]);

  useEffect(() => {
    // US , AU, CA
    if (age) {
      setConversion(null);
      // setLoading(true);
      setCountryCode(age);

      const control = countryIdentificationControl?.some((item, idx) => {
        return item?.includes(age);
      });

      setIdentificationControl(control);
      if (identificationControl) {
      }
      setIdentificationValue("");
      setSelectedValue("");
      setSelectedState("");
      setPayerDocument(null);
      setPaymentMethod(null);
      setState(null);

      if (age !== "IN") {
        setIndiaSourceOfFund?.(null);
        setIndiaDeclarationAmt?.("");
      }

      if (age === "US" || age === "AU" || age === "CA") {
        setStateCodeControl(true);
      } else {
        setStateCodeControl(false);
      }
      if (age === "CN") {
        setChineseNameControl(true);
      } else {
        setChineseNameControl(false);
      }
      setPayerStepConfirmed(false);
      setPanTouched(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [age]);

  useEffect(() => {
    setIdentificationValue("");
    setSelectedValue("");
    setSelectedState("");
    setPayerDocument(null);
    setPaymentMethod(null);
    setState(null);
    setIdentificationControl(false);
    setStateCodeControl(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setPayerDocument(identificationValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identificationValue]);

  useEffect(() => {
    // console.log(age, "age here");
  }, [age]);

  useEffect(() => {
    if (countriesInit !== undefined) {
      setCountries(countriesInit);
    }
  }, [countriesInit]);

  // const { data: conversionInit } = useSwr(
  //   API.TransferMate.Conversion.Get.create(age, totalPrice || 1200)
  // );

  const getConversions = async () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_URL}payment/transfermate/conversions?country_code=${age}&amount=${totalPrice}`;
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");

    try {
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
          XRefreshToken: `${token}`, // Bearer token burada ekleniyor
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });

      setConversion(response.data?.result?.rates?.rate);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("API isteği sırasında hata oluştu:", error);
    }
  };
  useEffect(() => {
    if (age && totalPrice && (!needsExtraPayerFields || payerStepConfirmed)) {
      getConversions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [age, totalPrice, needsExtraPayerFields, payerStepConfirmed]);

  // useEffect(() => {
  //   console.log(conversionInit, "conversion init");
  //   if (conversionInit) {
  //     setConversion(conversionInit?.result?.rates?.rate);
  //     setLoading(false);
  //   }
  // }, [conversionInit]);

  useEffect(() => {
    if (selectedValue) {
      if (conversion?.length) {
        const myItem = conversion?.find((item, idx) => {
          return item["@attributes"]?.type === selectedValue;
        });
        setPaymentMethod(myItem["@attributes"]?.payment_method_id);
      } else {
        setPaymentMethod(conversion["@attributes"]?.payment_method_id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue]);

  const showConversionOptions =
    Boolean(age && totalPrice) &&
    (!needsExtraPayerFields || payerStepConfirmed);

  const handlePayerStepSubmit = () => {
    if (!payerFieldsComplete) return;
    setSelectedValue("");
    setPaymentMethod(null);
    setPayerStepConfirmed(true);
    onPayerStepSubmitted?.();
  };

  const handleIndiaPanChange = (e) => {
    const v = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
    setIdentificationValue(v);
  };

  return countries ? (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: identificationControl
            ? { xs: "column", lg: "row" }
            : { xs: "column", sm: "row" },
          alignItems: "stretch",
        }}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: identificationControl
              ? stateCodeControl || chineseNameControl
                ? { xs: "column", md: "row", lg: "column", xl: "row" }
                : { xs: "column", sm: "row", xl: "row" }
              : stateCodeControl || chineseNameControl
                ? { xs: "column", md: "row" }
                : { xs: "column", xl: "row" },
            padding: "1rem",
            alignItems: "flex-start",
            marginRight: { xs: "0", sm: "2rem" },
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              width: identificationControl
                ? stateCodeControl || chineseNameControl
                  ? { xs: "100%", xl: "50%" }
                  : { xs: "100%", xl: "300px" }
                : stateCodeControl
                  ? "100%"
                  : { xs: "100%", sm: "300px" },
            }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                width: {
                  xs: "100%",
                  md:
                    stateCodeControl || chineseNameControl
                      ? identificationControl
                        ? "50%"
                        : "300px"
                      : "100%",
                  // md: identificationControl ? "fit-content" : "100%",
                },
              }}
            >
              <FormControl
                fullWidth
                disabled={
                  paymentType !== "invoice" &&
                  paymentType !== "booking" &&
                  !selectedStudent
                }
              >
                <InputLabel sx={{ textTransform: 'capitalize' }} id="demo-simple-select-label">
                  {t("paymentCountry")}
                </InputLabel>
                <Select
                  sx={{
                    minWidth: { xs: "100%", md: "150px" },
                    width:
                      identificationControl && !stateCodeControl
                        ? { xs: "100%", md: "100%" }
                        : { xs: "100%", md: "100%" },
                    marginTop: "auto",
                    marginBottom: "auto",
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age || "Choose Payment Country"}
                  label={t("paymentCountry")}
                  onChange={handleChange}
                  defaultValue={"Choose Payment Country"}
                >
                  <MenuItem disabled value="Choose Payment Country">
                    {t("choosePaymentCountry")}
                  </MenuItem>
                  {countries?.result?.countries?.country?.length
                    ? countries?.result?.countries?.country?.map(
                      (country, idx) => {
                        return (
                          <MenuItem
                            key={idx}
                            value={country["@attributes"]?.code}
                          >
                            {country?.name}
                          </MenuItem>
                        );
                      }
                    )
                    : null}
                </Select>
              </FormControl>
            </Box>
            {stateCodeControl ? (
              <Box
                fullWidth
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: identificationControl
                    ? { xs: "1rem", sm: "0", xl: "auto" }
                    : { xs: "1rem", sm: "auto" },
                  marginLeft: { xs: "0", sm: "1rem", xl: "1rem" },
                  width: {
                    xs: "100%",
                    md: stateCodeControl
                      ? identificationControl
                        ? "50%"
                        : "300px"
                      : "100%",
                    // md: identificationControl ? "fit-content" : "100%",
                  },
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">State</InputLabel>
                  <Select
                    sx={{
                      minWidth: { xs: "100%", md: "150px" },
                      width: identificationControl
                        ? { xs: "100%", md: "100%" }
                        : { xs: "100%", md: "300px" },
                      marginTop: "auto",
                      marginBottom: "auto",
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedState || "Choose Country State"}
                    label="Choose Country"
                    onChange={handleChangeState}
                    defaultValue={"Choose Country State"}
                  >
                    <MenuItem disabled value="Choose Country State">
                      Choose Country State
                    </MenuItem>
                    {stateCodes?.length
                      ? stateCodes
                        .filter((state) => {
                          if (age === "AU")
                            return state.country_name === "Australia";
                          if (age === "US")
                            return (
                              state.country_name ===
                              "United States Of America"
                            );
                          if (age === "CA")
                            return state.country_name === "Canada";
                          return false;
                        })
                        ?.map((state, idx) => {
                          return (
                            <MenuItem key={idx} value={state?.code}>
                              {state?.state_name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                </FormControl>
              </Box>
            ) : null}
            {chineseNameControl ? (
              <Box
                fullWidth
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  marginTop: identificationControl
                    ? { xs: "1rem", sm: "0", xl: "auto" }
                    : { xs: "1rem", sm: "auto" },
                  marginLeft: { xs: "0", sm: "1rem", xl: "1rem" },
                  width: {
                    xs: "100%",
                    md: chineseNameControl
                      ? identificationControl
                        ? "50%"
                        : "300px"
                      : "100%",
                    // md: identificationControl ? "fit-content" : "100%",
                  },
                }}
              >
                <TextField
                  onChange={handleChangeChineseName}
                  id="outlined-basic"
                  label="Name"
                  variant="outlined"
                />
              </Box>
            ) : null}
          </Box>
          {identificationControl ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width:
                  stateCodeControl || chineseNameControl
                    ? { xs: "100%", xl: "50%" }
                    : "100%",
                marginTop: identificationControl
                  ? stateCodeControl || chineseNameControl
                    ? { xs: "1rem", md: "0", lg: "1rem", xl: "auto" }
                    : { xs: "1rem", sm: "0", xl: "auto" }
                  : { xs: "1rem", md: "auto" },
                marginLeft:
                  stateCodeControl || chineseNameControl
                    ? { xs: "0", sm: "1rem", lg: "0", xl: "1rem" }
                    : { xs: "0", sm: "1rem", lg: "1rem", xl: "1rem" },
              }}
            >
              {age === "IN" ? (
                <TextField
                  fullWidth
                  required
                  value={identificationValue}
                  onChange={handleIndiaPanChange}
                  onBlur={() => setPanTouched(true)}
                  label="PAN / payer document number"
                  error={panTouched && !indiaPanFormatValid}
                  helperText={
                    panTouched && !indiaPanFormatValid
                      ? t("pan_error")
                      : panTouched && indiaPanFormatValid
                        ? t("pan_verified", {
                            defaultValue: "PAN format verified.",
                          })
                        : "Required by Indian regulations (10-character PAN, e.g. ABCDE1234F)."
                  }
                  FormHelperTextProps={
                    panTouched && indiaPanFormatValid
                      ? { sx: { color: "success.main" } }
                      : undefined
                  }
                  id="transfermate-india-pan"
                />
              ) : (
                <TextField
                  fullWidth
                  required
                  value={identificationValue}
                  sx={{ textTransform: "capitalize" }}
                  onChange={(e) => setIdentificationValue(e.target.value)}
                  label={t("identificationNumber")}
                  id="fullWidth"
                />
              )}
              {age === "IN" ? (
                <>
                  <FormControl fullWidth>
                    <InputLabel id="india-source-label">
                      Source of funds (India)
                    </InputLabel>
                    <Select
                      labelId="india-source-label"
                      label="Source of funds (India)"
                      value={indiaSourceOfFund ?? ""}
                      onChange={(e) =>
                        setIndiaSourceOfFund?.(e.target.value || null)
                      }
                    >
                      <MenuItem value="" disabled>
                        Select one
                      </MenuItem>
                      <MenuItem value="resident_savings">
                        Resident savings
                      </MenuItem>
                      <MenuItem value="education_loan">
                        Education loan
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    type="text"
                    inputMode="decimal"
                    label="Cumulative INR — foreign exchange this financial year"
                    helperText="Required under Indian regulatory guidelines."
                    value={indiaDeclarationAmt ?? ""}
                    onChange={(e) =>
                      setIndiaDeclarationAmt?.(e.target.value)
                    }
                  />
                </>
              ) : null}
              {needsExtraPayerFields && age && !payerStepConfirmed ? (
                <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: ".5rem" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handlePayerStepSubmit}
                    disabled={!payerFieldsComplete}
                  >
                    {t("submit", { defaultValue: "Submit" })}
                  </Button>
                </Box>
              ) : null}
            </Box>
            ) : null}
          {!identificationControl && needsExtraPayerFields && age && !payerStepConfirmed ? (
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", marginTop: ".5rem" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handlePayerStepSubmit}
                disabled={!payerFieldsComplete}
              >
                {t("submit", { defaultValue: "Submit" })}
              </Button>
            </Box>
          ) : null}
        </Card>
      </Box>
      {!loading ? (
        conversion && showConversionOptions ? (
          <Box
            sx={{ marginTop: "3rem", display: "flex", flexDirection: "column" }}
          >
            <FormControl component="fieldset">
              <FormLabel
                sx={{
                  fontSize: "24px",
                  borderBottom: "1px solid #efefef",
                  paddingBottom: ".5rem",
                  marginBottom: "2rem",
                  textTransform: 'capitalize'
                }}
                component="legend"
              >
                {t("selectPaymentMethod")}
              </FormLabel>
              <RadioGroup
                value={selectedValue}
                onChange={handleChangeConversion}
              >
                <Grid container spacing={2}>
                  {conversion?.length ? (
                    <>
                      {/* {paymentMethods
                .filter((paymentMethod) =>
                  bookingId ? paymentMethod.name !== "transfermate" : true
                )
                .map((paymentMethod, idx) => { */}
                      {conversion
                        .filter(
                          (conversion) =>
                            conversion["@attributes"].type !== "Bank Transfer"
                        )
                        .map((conversion, idx) => (
                          <ConversionItem
                            type={"multiple"}
                            idx={idx}
                            conversion={conversion}
                            lightMode={lightMode}
                            selectedValue={selectedValue}
                          />
                        ))}
                    </>
                  ) : (
                    <ConversionItem
                      type={"single"}
                      conversion={conversion}
                      lightMode={lightMode}
                      selectedValue={selectedValue}
                    />
                  )}
                </Grid>
              </RadioGroup>
            </FormControl>
          </Box>
        ) : null
      ) : (
        <CircularProgress />
      )}
    </Box>
  ) : (
    <CircularProgress />
  );
}
